import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const categoryCardVariants = cva(
  "bg-white rounded-xl border border-gray-200 p-4 hover:shadow-lg transition-all duration-200 cursor-pointer group"
);

const iconVariants = {
  work: { icon: "fa-solid fa-briefcase", color: "bg-blue-100 text-blue-600" },
  ideas: { icon: "fa-solid fa-lightbulb", color: "bg-purple-100 text-purple-600" },
  personal: { icon: "fa-solid fa-user", color: "bg-green-100 text-green-600" },
  marketing: { icon: "fa-solid fa-bullhorn", color: "bg-yellow-100 text-yellow-600" },
  development: { icon: "fa-solid fa-code", color: "bg-gray-100 text-gray-600" },
  design: { icon: "fa-solid fa-palette", color: "bg-pink-100 text-pink-600" },
};

const countColors = {
  work: "text-blue-600",
  ideas: "text-purple-600", 
  personal: "text-green-600",
  marketing: "text-yellow-600",
  development: "text-gray-600",
  design: "text-pink-600",
};

export const CategoryCard = React.forwardRef(({
  className,
  name,
  itemCount = 0,
  associatedNumber,
  type = "work",
  showAdd = false,
  onClick,
  ...props
}, ref) => {
  const iconConfig = iconVariants[type] || iconVariants.work;
  const countColor = countColors[type] || countColors.work;

  return (
    <div
      ref={ref}
      className={cn(categoryCardVariants(), className)}
      onClick={onClick}
      {...props}
    >
      <div className="flex items-center justify-between">
        {/* Icon and Info */}
        <div className="flex items-center space-x-3">
          <div className={cn(
            "w-8 h-8 rounded-lg flex items-center justify-center",
            iconConfig.color
          )}>
            <i className={cn(iconConfig.icon, "text-sm")} />
          </div>
          
          <div>
            <h3 className="text-sm font-medium text-gray-900 group-hover:text-gray-700">
              {name}
            </h3>
            <p className="text-xs text-gray-500">
              {itemCount} {itemCount === 1 ? 'item' : 'items'}
            </p>
          </div>
        </div>

        {/* Associated Number or Add Button */}
        <div className="flex items-center">
          {showAdd ? (
            <button className="w-6 h-6 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors">
              <i className="fa-solid fa-plus text-xs text-gray-600" />
            </button>
          ) : associatedNumber !== undefined ? (
            <span className={cn("text-lg font-semibold", countColor)}>
              {associatedNumber}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
});

CategoryCard.displayName = "CategoryCard"; 